import fetchAPI from '../../../utils/fetchApi';

export default async function getFeeds(l1CategoryId) {
  try {
    return await fetchAPI({ url: `/cp/api/feeds?categoryId=${l1CategoryId}` });
  } catch {
    return false;
  }
}
